<template>
  <div class="content">

<!-- 科技成果数据库详情弹窗 -->
<el-dialog
  v-model="dialogVisible"
  :title="dialogTitle"
  width="900px"
  :before-close="handleClose"
  class="custom-dialog"
>
  <div class="dialog-content">
    <!-- 科技成果数据库 -->
    <div v-if="tabis === '科技成果数据库'" class="detail-section">
      <div class="detail-item">
        <div class="detail-label">成果名称：</div>
        <div class="detail-value">{{ xqdata.achievementName }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">服务产业：</div>
        <div class="detail-value">{{ xqdata.industryType }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">成果介绍：</div>
        <div class="detail-value">{{ xqdata.achievementIntro }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">应用情况：</div>
        <div class="detail-value">{{ xqdata.applicationStatus }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">团队介绍：</div>
        <div class="detail-value">{{ xqdata.teamIntro }}</div>
      </div>
      <div class="detail-item contact-info">
        <div class="detail-label">联系人：</div>
        <div class="detail-value">{{ xqdata.contactPerson }}</div>
        <div class="detail-label" style="margin-left: 40px;">联系方式：</div>
        <div class="detail-value">{{ xqdata.contactInfo }}</div>
      </div>
    </div>

    <!-- 专利技术数据库 -->
    <div v-if="tabis === '专利技术数据库'" class="detail-section">
      <div class="detail-item">
        <div class="detail-label">专利名称：</div>
        <div class="detail-value">{{ xqdata.title }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">专利类型：</div>
        <div class="detail-value">{{ xqdata.patentType }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">申请方：</div>
        <div class="detail-value">{{ xqdata.applicant }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">发明人：</div>
        <div class="detail-value">{{ xqdata.inventorDesigner }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">申请日期：</div>
        <div class="detail-value">{{ xqdata.applicationDate }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">状态：</div>
        <div class="detail-value">{{ xqdata.status || '暂无' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">专利摘要：</div>
        <div class="detail-value">{{ xqdata.abstractText || '暂无摘要信息' }}</div>
      </div>
    </div>

    <!-- 专家数据库 -->
    <div v-if="tabis === '专家数据库'" class="detail-section">
      <div class="detail-item">
        <div class="detail-label">专家姓名：</div>
        <div class="detail-value">{{ xqdata.userName }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">专家资质：</div>
        <div class="detail-value">{{ xqdata.qualification }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">所属单位：</div>
        <div class="detail-value">{{ xqdata.affiliatedUnit }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">专家介绍：</div>
        <div class="detail-value">{{ xqdata.introduce }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">研究方向：</div>
        <div class="detail-value">{{ xqdata.researchDirection || '暂无信息' }}</div>
      </div>
      <div class="detail-item contact-info">
        <div class="detail-label">联系方式：</div>
        <div class="detail-value">{{ xqdata.contactInfo || '暂无联系方式' }}</div>
      </div>
    </div>

    <!-- 企业数据库 -->
    <div v-if="tabis === '企业数据库'" class="detail-section">
      <div class="detail-item">
        <div class="detail-label">企业名称：</div>
        <div class="detail-value">{{ xqdata.enterpriseName }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">企业简介：</div>
        <div class="detail-value">{{ stripHtmlTags(xqdata.companyProfile) }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">所属行业：</div>
        <div class="detail-value">{{ xqdata.industry || '暂无信息' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">企业地址：</div>
        <div class="detail-value">{{ xqdata.address || '暂无地址信息' }}</div>
      </div>
      <div class="detail-item contact-info">
        <div class="detail-label">联系人：</div>
        <div class="detail-value">{{ xqdata.contactPerson || '暂无' }}</div>
        <div class="detail-label" style="margin-left: 40px;">联系方式：</div>
        <div class="detail-value">{{ xqdata.contactInfo || '暂无' }}</div>
      </div>
    </div>

    <!-- 科技项目数据库 -->
    <div v-if="tabis === '科技项目数据库'" class="detail-section">
      <div class="detail-item">
        <div class="detail-label">项目名称：</div>
        <div class="detail-value">{{ xqdata.xmmc }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">所属领域：</div>
        <div class="detail-value">{{ xqdata.ssly }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">单位企业：</div>
        <div class="detail-value">{{ xqdata.dwqy }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">项目介绍：</div>
        <div class="detail-value">{{ xqdata.projectIntro || '暂无项目介绍' }}</div>
      </div>
      <div class="detail-item contact-info">
        <div class="detail-label">联系方式：</div>
        <div class="detail-value">{{ xqdata.lxfs }}</div>
      </div>
    </div>
  </div>
</el-dialog>
    
<!-- 顶部横幅 -->
<div class="banner-section">
  <img src="../assets/img/sjzy/sjzy.png" alt="" class="banner-image">
  <div class="banner-overlay">
    <h1 class="banner-title">
      <span class="title-white">整合数据资源</span>
      <span class="title-gradient">激发智慧洞察</span>
    </h1>
  </div>
</div>

<!-- 数据资源区域 -->
<div class="data-resource-section">
  <div class="section-header">
    <div class="header-title">数据资源</div>
  </div>

  <!-- 白色容器包裹标签页和表格 -->
  <div class="data-content-wrapper">
    <!-- 标签页 -->
    <div class="tabs-container">
      <div class="tabs-wrapper">
        <div 
          v-for="(item, index) in tablists" 
          :key="index" 
          :class="['tab-item', { 'tab-active': tabis === item }]"
          @click="tabchange(item)"
        >
          {{ item }}
          <div class="tab-underline" v-if="tabis === item"></div>
        </div>
      </div>
      <!-- 搜索框 -->
      <div class="search-box">
        <svg class="filter-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 4h12M4 8h8M6 12h4" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <input 
          type="text" 
          placeholder="输入关键词搜索..." 
          class="search-input" 
          v-model="searchKeyword"
          @keyup.enter="handleSearch"
        />
        <svg 
          class="search-icon" 
          width="16" 
          height="16" 
          viewBox="0 0 16 16" 
          fill="none"
          style="cursor: pointer;"
          @click="handleSearch"
        >
          <circle cx="7" cy="7" r="5" stroke="#9CA3AF" stroke-width="1.5"/>
          <path d="M11 11L14 14" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        empty-text="暂无数据"
        height="100%"
        :header-cell-style="{ 
          backgroundColor: '#F9FAFB', 
          color: '#6B7280', 
          fontSize: '14px', 
          fontWeight: '500',
          borderBottom: '1px solid #E5E7EB',
          height: '56px'
        }"
        :cell-style="{ 
          borderBottom: '1px solid #F3F4F6',
          color: '#374151',
          fontSize: '14px',
          backgroundColor: '#FFFFFF'
        }"
        ref="gocarTable1"
        :data="tableData" 
        tooltip-effect="dark" 
        style="width: 100%; height: 280px;" 
        @select="gocarlistset"
        :default-sort="{ prop: 'date', order: 'descending' }"
        :row-class-name="tableRowClassName"
        @cell-click="goxq"
      >
        <el-table-column
          :prop="tabis=='专家数据库'?'userName':tabis=='科技成果数据库'?'achievementName':tabis=='专利技术数据库'?'title':tabis=='企业数据库'?'enterpriseName':'xmmc'"
          :label="tabis=='科技成果数据库'?'科创成果名称':tabis=='专家数据库'?'专家姓名':tabis=='企业数据库'?'企业名称':'专利名称'"
          show-overflow-tooltip
          align="left"
          min-width="280"
        >
          <template #default="scope">
            <div class="table-cell-content">
              <svg class="cell-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="3" y="2" width="10" height="12" rx="1" stroke="#3B82F6" stroke-width="1.5" fill="none"/>
                <line x1="5" y1="5" x2="11" y2="5" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="5" y1="8" x2="9" y2="8" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span class="cell-text">{{ scope.row[tabis=='专家数据库'?'userName':tabis=='科技成果数据库'?'achievementName':tabis=='专利技术数据库'?'title':tabis=='企业数据库'?'enterpriseName':'xmmc'] }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          :prop="tabis=='专家数据库'?'qualification':tabis=='科技成果数据库'?'industryType':tabis=='专利技术数据库'?'patentType':tabis=='企业数据库'?'companyProfile':'ssly'"
          :label="tabis=='科技成果数据库'?'所属领域':tabis=='专家数据库'?'专家类型':tabis=='企业数据库'?'企业简介':'专利类型'"
          show-overflow-tooltip
          align="center"
          min-width="120"
        >
          <template #default="scope">
            <!-- 企业数据库显示普通文本，去除HTML标签 -->
            <span v-if="tabis=='企业数据库'" class="company-profile-text">
              {{ stripHtmlTags(scope.row.companyProfile) }}
            </span>
            <!-- 其他数据库显示标签 -->
            <el-tag 
              v-else
              size="small" 
              type="info"
              effect="plain"
              class="custom-tag"
            >
              {{ scope.row[tabis=='专家数据库'?'qualification':tabis=='科技成果数据库'?'industryType':tabis=='专利技术数据库'?'patentType':'ssly'] }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column
          v-if="tabis!='企业数据库'"
          :prop="tabis=='专家数据库'?'affiliatedUnit':tabis=='科技成果数据库'?'declarationUnit':tabis=='专利技术数据库'?'applicant':'dwqy'"
          :label="tabis=='专家数据库'?'所属单位':tabis=='科技成果数据库'?'所属院系':'申请方'"
          align="center"
          show-overflow-tooltip
          min-width="200"
        > 
        </el-table-column>
        
        <el-table-column
          v-if="tabis!='企业数据库'"
          :prop="tabis=='专家数据库'?'introduce':tabis=='科技成果数据库'?'createTime':tabis=='专利技术数据库'?'inventorDesigner':'lxfs'"
          :label="tabis=='专家数据库'?'专家介绍':tabis=='科技成果数据库'?'创建时间':'发明人'"
          align="center"
          show-overflow-tooltip
          min-width="180"
        >
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <div class="pagination-info" v-if="listnum > 0">共 {{ listnum }} 条数据</div>
        <el-pagination
          v-if="listnum > 0"
          class="custom-pagination"
          :page-size="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="listnum"
        />
      </div>
    </div>
  </div>
</div>

  </div>
</template>
  
  <script>
  
  
  import { getAction, patentAction } from '@/api/requests'
  
  export default {
    name: 'sjzyContent',
    components: {
  
     
    },
    props: {
          idsss: {
      type: String,
      default: '',
    },
          initialTab: {
      type: String,
      default: '',
    },},
    data(){
 
      return{
        dialogVisible: false,
        dialogTitle: '',
        loading:false,
        listnum:0,
        xqdata:{},
        searchKeyword: '', // 搜索关键词
        tableData:[
        //   {
        //   xmmc:'',
        //   ssly:'',
        //   dwqy:'',
        //   lxfs:''

        // },{
        //   xmmc:'',
        //   ssly:'',
        //   dwqy:'',
        //   lxfs:''

        // },{
        //   xmmc:'',
        //   ssly:'',
        //   dwqy:'',
        //   lxfs:''

        // },{
        //   xmmc:'',
        //   ssly:'',
        //   dwqy:'',
        //   lxfs:''

        // },{
        //   xmmc:'',
        //   ssly:'',
        //   dwqy:'',
        //   lxfs:''

        // },{
        //   xmmc:'',
        //   ssly:'',
        //   dwqy:'',
        //   lxfs:''

        // },
      ],
        tablists:['专利技术数据库','科技成果数据库','科技项目数据库','专家数据库','企业数据库'],
        tabis:'专利技术数据库'
      }
    },
    
    watch: {
      idsss:{
      handler(val) {
   
        console.log(val);
        this.getzlsjlist()
      }
    },
      initialTab:{
      handler(val) {
        if(val && this.tablists.includes(val)){
          this.tabis = val
          this.getzlsjlist()
        }
      },
      immediate: true
    }
    },
    mounted(){
      this.getzlsjlist()
    },
    methods:{
      // 去除HTML标签
      stripHtmlTags(html) {
        if (!html) return ''
        // 创建一个临时div元素来解析HTML
        const tmp = document.createElement('div')
        tmp.innerHTML = html
        // 返回纯文本内容
        return tmp.textContent || tmp.innerText || ''
      },

      // 搜索处理
      handleSearch() {
        // 重新加载第一页数据
        if(this.tabis == '专家数据库'){
          this.getzjsjlist(1)
        }else if(this.tabis == '科技成果数据库'){
          this.getkccglist(1)
        }else if(this.tabis == '企业数据库'){
          this.getqysjlist(1)
        }else if(this.tabis == '专利技术数据库'){
          this.getzlsjlist(1)
        }
      },

      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false
        this.xqdata = {}
      },

      // 打开详情弹窗
      goxq(row) {
        console.log('点击行:', row)
        
        // 科技成果数据库
        if(this.tabis === '科技成果数据库'){
          if(row.opType == null || row.opType == 1){
            getAction("/edu/declaration/" + row.id).then(res => {
              this.xqdata = res.data
              this.dialogTitle = '科技成果详情'
              this.dialogVisible = true
            })
          }
        }
        // 专利技术数据库
        else if(this.tabis === '专利技术数据库'){
          this.xqdata = row
          this.dialogTitle = '专利技术详情'
          this.dialogVisible = true
        }
        // 专家数据库
        else if(this.tabis === '专家数据库'){
          this.xqdata = row
          this.dialogTitle = '专家信息详情'
          this.dialogVisible = true
        }
        // 企业数据库
        else if(this.tabis === '企业数据库'){
          this.xqdata = row
          this.dialogTitle = '企业信息详情'
          this.dialogVisible = true
        }
        // 科技项目数据库
        else if(this.tabis === '科技项目数据库'){
          this.xqdata = row
          this.dialogTitle = '科技项目详情'
          this.dialogVisible = true
        }
      },
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        if(this.tabis=='专家数据库'){
  this.getzjsjlist(val)
}else if(this.tabis=='科技成果数据库'){
this.getkccglist(val)
}else if(this.tabis=='企业数据库'){
  this.getqysjlist(val)
}else if(this.tabis=='专利技术数据库'){
  this.getzlsjlist(val)
}

      },
      tabchange(item){
        this.loading=false
this.tabis = item
this.tableData = []
this.listnum =0
this.searchKeyword = '' // 切换tab时清空搜索关键词
if(item=='专家数据库'){
  this.getzjsjlist()
}else if(item=='科技成果数据库'){
this.getkccglist()
}else if(item=='企业数据库'){
  this.getqysjlist()
}else if(item=='专利技术数据库'){
  this.getzlsjlist()
}

      },
      // 专家数据
      getzjsjlist(e=1){
        this.loading = true
      let data = {
        pageNum: e,
        pageSize: 5,
        keyword: this.searchKeyword || undefined
      }
      // 根据是否有搜索关键词选择接口
      const apiUrl = this.searchKeyword ? "/edu/expert/search" : "/edu/expert/list"
      getAction(apiUrl, data).then(res => {
        this.listnum = res.total
        let datas = []
        res.rows.forEach((element,index) => {
   if(index<5){
    datas.push(element)
   }
        });
        this.tableData = datas
        this.loading = false
        console.log(res)
     
      })
    },
          // 科技成果数据库
  //         getkccglist(e=1){
  //       this.loading = true
  //     let data = {
  //       pageNum: e,
  //   pageSize: 5,
        
  //     }
  //     getAction("/edu/achievements/list", data).then(res => {
  //       this.listnum = res.total
  //       let datas = []
  //       res.rows.forEach((element,index) => {
  //  if(index<5){
  //   datas.push(element)
  //  }
  //       });
  //       this.tableData = datas
  //       this.loading = false
  //       console.log(res)
     
  //     })
  //   },
  // 科技成果新接口
   getkccglist(e=1){
        this.loading = true
      let data = {
        pageNum: e,
        pageSize: 5,
        keyword: this.searchKeyword || undefined
      }
      // 根据是否有搜索关键词选择接口
      const apiUrl = this.searchKeyword ? "/edu/declaration/search" : "/edu/declaration/list"
      getAction(apiUrl, data).then(res => {
        this.listnum = res.total
        let datas = []
        res.rows.forEach((element,index) => {
   if(index<5){
    datas.push(element)
   }
        });
        this.tableData = datas
        this.loading = false
        console.log(res)
     
      })
    },
    // 企业数据
    
    getqysjlist(e=1){
        this.loading = true
      let data = {
        pageNum: e,
        pageSize: 5,
        keyword: this.searchKeyword || undefined
      }
      // 根据是否有搜索关键词选择接口
      const apiUrl = this.searchKeyword ? "/edu/information/search" : "/edu/information/list"
      getAction(apiUrl, data).then(res => {
        console.log('企业数据库API返回数据:', res)
        this.listnum = res.total
        let datas = []
        if (res.rows && res.rows.length > 0) {
          res.rows.forEach((element,index) => {
     if(index<5){
      datas.push(element)
     }
          });
        } else {
          console.log('企业数据库返回空数据')
        }
        this.tableData = datas
        this.loading = false
        console.log('企业数据库最终数据:', this.tableData)
     
      }).catch(error => {
        console.error('企业数据库API调用错误:', error)
        this.loading = false
        this.tableData = []
      })
    },
     // 专利数据
    
     getzlsjlist(e=1){
        this.loading = true
      let data = {
        pageNum: e,
        pageSize: 5,
        keyword: this.searchKeyword || undefined
      }
      // 根据是否有搜索关键词选择接口
      const apiUrl = this.searchKeyword ? "/zscq/patent/search" : "/zscq/patent/list"
      patentAction(apiUrl, data).then(res => {
        this.listnum = res.total
        let datas = []
        res.rows.forEach((element,index) => {
   if(index<5){
    datas.push(element)
   }
        });
        this.tableData = datas
        this.loading = false
        console.log(res)
     
      })
    },
    }
  }
  </script>
  
  <style scoped>
/* 自定义弹窗样式 */
:deep(.custom-dialog) {
  border-radius: 16px;
}

:deep(.custom-dialog .el-dialog__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 32px;
  border-radius: 16px 16px 0 0;
  margin: 0;
}

:deep(.custom-dialog .el-dialog__title) {
  font-size: 20px;
  font-weight: 600;
  color: #FFFFFF;
}

:deep(.custom-dialog .el-dialog__headerbtn) {
  width: 36px;
  height: 36px;
  top: 24px;
  right: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

:deep(.custom-dialog .el-dialog__headerbtn:hover) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

:deep(.custom-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  position: static;
  top: auto;
  right: auto;
}

:deep(.custom-dialog .el-dialog__headerbtn:hover .el-dialog__close) {
  color: #FFFFFF;
}

:deep(.custom-dialog .el-dialog__body) {
  padding: 32px;
  max-height: 600px;
  overflow-y: auto;
}

/* 详情内容样式 */
.dialog-content {
  width: 100%;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border-left: 3px solid #3B82F6;
  transition: all 0.3s;
}

.detail-item:hover {
  background: #F3F4F6;
  border-left-color: #2563EB;
}

.detail-label {
  min-width: 100px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  word-break: break-word;
}

.contact-info {
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  border-left-color: #3B82F6;
}

.contact-info .detail-label {
  color: #1E40AF;
}

.contact-info .detail-value {
  color: #1E3A8A;
  font-weight: 500;
}

/* 滚动条样式 */
:deep(.el-dialog__body)::-webkit-scrollbar {
  width: 6px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.banner-title {
  font-size: 48px;
  font-weight: 600;
  margin: 0;
  display: flex;
  gap: 16px;
}

.title-white {
  color: #FFFFFF;
}

.title-gradient {
background: linear-gradient(0deg, #155DFC 0%, #00B8DB 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 数据资源区域 */
.data-resource-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -80px;
  z-index: 10;
  padding-bottom: 60px;
}

.section-header {
  position: relative;
  text-align: center;
  margin-bottom: 30px;
}

.header-bg-text {
  font-size: 14px;
  font-weight: 400;
  color: #9CA3AF;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.header-title {
  position: relative;
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
  padding-bottom: 8px;
}

.header-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background:#155DFC;
  border-radius: 2px;
}

/* 白色容器 */
.data-content-wrapper {
  width: 1200px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 标签页容器 */
.tabs-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #E5E7EB;
}

.tabs-wrapper {
  display: flex;
  gap: 0;
  background: #F3F4F6;
  border-radius: 8px;
  padding: 4px;
}

.tab-item {
  position: relative;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 6px;
  white-space: nowrap;
}

.tab-item:hover {
  color: #3B82F6;
}

.tab-active {
  background: #3B82F6;
  color: #FFFFFF !important;
  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.3);
}

.tab-underline {
  display: none;
}

/* 搜索框 */
.search-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 24px;
  width: 420px;
}

.search-icon {
  flex-shrink: 0;
  order: -1;
}

.filter-icon {
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.3s;
  order: -2;
}

.filter-icon:hover {
  opacity: 0.7;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #374151;
  order: 0;
}

.search-input::placeholder {
  color: #C4C9D4;
}

/* 表格区域 */
.table-section {
  width: 100%;
}

.table-cell-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cell-icon {
  flex-shrink: 0;
}

.cell-text {
  color: #374151;
  font-weight: 400;
}

/* 自定义标签 */
:deep(.custom-tag) {
  background: #EFF6FF;
  border-color: #BFDBFE;
  color: #3B82F6;
  font-size: 12px;
  font-weight: 500;
}

/* 企业简介文本样式 */
.company-profile-text {
  font-size: 14px;
  color: #6B7280;
  line-height: 1.5;
  display: block;
  text-align: left;
  padding: 0 8px;
}

/* 表格样式 */
:deep(.el-table) {
  background-color: #FFFFFF;
  color: #374151;
}

:deep(.el-table tr) {
  background-color: #FFFFFF;
}

:deep(.el-table .warning-row) {
  background: #FFFFFF;
}

:deep(.el-table .success-row) {
  background: #F9FAFB;
}

:deep(.el-table__inner-wrapper:before) {
  width: 0;
}

:deep(.el-table__body-wrapper) {
  background-color: #FFFFFF;
}

:deep(.el-table th.el-table__cell) {
  background-color: #F9FAFB;
  color: #6B7280;
  font-weight: 500;
}

:deep(.el-table td.el-table__cell) {
  color: #374151;
}

:deep(.el-table__row:hover > td) {
  background-color: #F9FAFB !important;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #E5E7EB;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #3B82F6 !important;
  color: #FFFFFF !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.disabled)) {
  background-color: #FFFFFF !important;
  color: #6B7280 !important;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:hover) {
  color: #3B82F6 !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next),
:deep(.custom-pagination.el-pagination.is-background .btn-prev) {
  background-color: #FFFFFF;
  color: #6B7280;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:hover),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:hover) {
  color: #3B82F6;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:disabled),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:disabled) {
  background-color: #F9FAFB;
  color: #D1D5DB;
  border-color: #E5E7EB;
}
</style>
  
  